import React, { createContext, useReducer } from 'react'

export const SET_PLUGIN_DATA = 'SET_PLUGIN_DATA'
export const UPDATE_PLUGIN_DATA = 'UPDATE_PLUGIN_DATA'
export const SET_SELECTED_PLUGIN_DATA = 'SET_SELECTED_PLUGIN_DATA'
export const SET_SELECTED_IDS = 'SET_SELECTED_IDS'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_PLUGIN_DATA: {
      return { ...data, data: payload.data }
    }
    case UPDATE_PLUGIN_DATA: {
      let tempData = [...data.data]
      tempData[payload.data.index] = payload.data
      return { ...data, data: tempData }
    }
    case SET_SELECTED_PLUGIN_DATA: {
      return { ...data, selectedObject: payload.data }
    }
    case SET_SELECTED_IDS: {
      let tempSelectedIds = [...data.selectedIds]
      let item = payload.data
      tempSelectedIds.indexOf(item) === -1
        ? tempSelectedIds.push(item)
        : tempSelectedIds.splice(tempSelectedIds.indexOf(item), 1)
      return { ...data, selectedIds: tempSelectedIds }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: [],
  selectedObject: {},
  selectedIds: [],
}

const PluginStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <PluginContext.Provider value={[state, dispatch]}>
      {children}
    </PluginContext.Provider>
  )
}

export const PluginContext = createContext(initialState)
export default PluginStore
